var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCameraBloc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BLOC CAMERA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON CAMERA"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.5873 37.0271C46.8124 35.4304 47.0271 34.0325 47.4329 32.4656C47.5773 31.9027 47.7755 31.1481 47.3852 30.631C46.0027 28.7852 42.861 28.247 40.7747 27.793C37.4554 27.0697 33.6269 26.4633 30.236 27.0351C27.2883 27.5312 27.2494 31.9282 27.1541 34.4075M31.2561 35.0218C31.3039 33.8712 31.4506 32.7518 31.8661 31.669C32.3593 30.3837 36.0406 30.8917 36.984 30.9353C38.3622 30.9982 39.7384 31.2094 41.0489 31.6399C43.3599 32.3982 42.6473 34.6573 42.1333 36.2956M28.5248 34.8777C22.9299 34.0851 15.9093 33.0659 10.2777 33.5816C10.2476 33.5841 10.2223 33.6022 10.1922 33.6047C10.1694 33.6084 10.1477 33.6048 10.1236 33.6157C10.1079 33.6205 10.0983 33.6338 10.0827 33.6387C10.0502 33.6556 10.0177 33.6726 9.99247 33.6907C9.22968 34.0852 8.94786 35.1231 8.73404 35.8825C8.02685 38.3802 7.67525 40.9733 7.34286 43.54C6.61645 49.0938 6.37438 54.6827 5.75038 60.2459C5.39293 63.4173 3.75133 69.6154 7.9075 70.7138C13.5378 72.1953 19.5849 72.1339 25.3199 73.0683C34.6642 74.588 44.0692 75.7835 53.4999 76.6862C55.0868 76.8354 56.9306 77.1382 58.3438 76.2193C59.7402 75.3125 59.811 72.6657 60.0426 71.2558C61.3518 63.1022 63.7403 54.8882 64.0591 46.6165C64.1228 45.0081 64.1352 42.6266 62.8938 41.3683C61.0438 39.4754 56.8188 39.2939 54.3599 38.7119C51.7516 38.0905 49.1268 37.6149 46.4998 37.1983L28.526 34.8704L28.5248 34.8777Z",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.6093 54.9497C47.6352 58.7261 46.4012 62.5779 44.0531 65.5264C41.3688 68.8949 36.7728 69.7514 32.6884 69.4371C26.1907 68.9418 21.5741 63.6838 20.6016 57.4871C19.5412 50.7413 23.3715 44.5091 29.343 41.5616C39.1769 37.7485 47.5388 45.0695 47.6105 54.9425L47.6093 54.9497Z",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.6335 38.7994C16.7129 37.668 15.2268 37.3126 14.0121 38.1527C13.917 38.1891 13.8268 38.2411 13.7572 38.3485C13.0585 39.3476 12.8233 40.7346 13.5184 41.7919C14.3188 43.0223 16.7394 43.2044 17.8177 42.29C18.9033 41.3767 18.3995 39.742 17.6335 38.7994Z",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.8441 48.2177C26.9451 49.6309 26.3194 56.6738 30.8995 60.0591",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.8464 60.7073C38.1123 60.2347 40.4246 58.1458 40.8328 55.0894C41.1487 52.7371 40.5375 49.7495 37.7041 49.0159",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ICON LINES"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M79.2085 31.8853L86.3315 31.1701",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M76.6721 23.0499L90.7554 14.0548",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M70.6549 18.3544L75.5166 10.8468",
    stroke: "#EF7056",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "ICON LINES_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M66.1198 89.5425L68.8076 96.1777",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M73.8863 84.6254L86.4761 95.6139",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M76.7023 77.5316L85.2734 80.088",
    stroke: "#EF7056",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraBloc);
export default __webpack_public_path__ + "static/media/icon-camera-bloc.2b0bc365a038b93ba2caacbff26b3777.svg";
export { ForwardRef as ReactComponent };